<div class="bg">
  <section class="container-wrapper">
    <div class="logo">
      <img src="assets/logo-white.png" class="brand img-fluid bg-transparent" alt="">
    </div>
    <app-signup-form></app-signup-form>
  </section>
</div>

